import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

function CTA() {
  return (
    <MKBox pt={20} pb={14} sx={{ background: "#32373c" }}>
      <Container maxWidth="sm">
        <MKBox textAlign="center">
          <MKTypography
            variant="caption"
            sx={{
              color: "rgba(255,255,255,0.5)",
              fontWeight: 600,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              display: "block",
              mb: 1.5,
            }}
          >
            Get a Quote
          </MKTypography>
          <MKTypography variant="h2" color="white" fontWeight="bold" mb={2}>
            Ready to get started?
          </MKTypography>
          <MKTypography
            variant="body1"
            sx={{ color: "rgba(255,255,255,0.7)", mb: 5, lineHeight: 1.8 }}
          >
            Tell us what your facility needs and we&apos;ll put together a tailored quote — no
            obligation, no hidden charges.
          </MKTypography>

          <MKButton
            variant="contained"
            size="large"
            onClick={() => window.dispatchEvent(new Event("open-supplies-form"))}
            sx={{
              background: "#ff9f1c",
              color: "white",
              boxShadow: "none",
              fontWeight: 700,
              "&:hover": { background: "#e07000", boxShadow: "none" },
            }}
          >
            Request a Quote
          </MKButton>

          <MKTypography
            variant="body2"
            sx={{ color: "rgba(255,255,255,0.55)", display: "block", mt: 3 }}
          >
            Or email us at{" "}
            <MKTypography
              component="a"
              href="mailto:info@spechs.ie?subject=Supplies Inquiry"
              variant="body2"
              sx={{ color: "white !important", fontWeight: "bold", textDecoration: "underline" }}
            >
              info@spechs.ie
            </MKTypography>
          </MKTypography>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default CTA;
